import { useNavigation } from "@react-navigation/native";
import { StackScreenProps } from "@react-navigation/stack";
import { RootStackParamList } from "../navigations/RootNavigation";
import { useEffect } from "react";

type ScreenParams = StackScreenProps<RootStackParamList>;

export const useNavigationHeader = (title?: string | null) => {
    const navigator = useNavigation<ScreenParams["navigation"]>();

    useEffect(() => {
        navigator.setOptions({
            title: title || "",
        });
    }, [navigator, title]);
};

export const useShowHideHeader = (action?: "show" | "hide") => {
    const navigator = useNavigation<ScreenParams["navigation"]>();

    useEffect(() => {
        if (action === "hide") {
            navigator.setOptions({
                headerShown: false,
            });
        } else {
            navigator.setOptions({
                headerShown: true,
            });
        }
    }, [navigator, action]);
};
